// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Wp0vx"};